// frontend/utils/deviceFingerprint.js
// Generate a unique device fingerprint for anonymous session tracking

/**
 * Generate a device fingerprint based on browser characteristics
 * This is a simple fingerprint - for production, consider using a library like fingerprintjs
 */
export function generateDeviceFingerprint() {
  const components = [
    navigator.userAgent || '',
    navigator.language || '',
    navigator.languages?.join(',') || '',
    screen.width + 'x' + screen.height,
    new Date().getTimezoneOffset().toString(),
    navigator.hardwareConcurrency?.toString() || '',
    navigator.deviceMemory?.toString() || '',
  ];

  // Create a simple hash from components
  const fingerprintString = components.join('|');
  
  // Simple hash function (for production, use crypto.subtle.digest)
  let hash = 0;
  for (let i = 0; i < fingerprintString.length; i++) {
    const char = fingerprintString.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  
  return Math.abs(hash).toString(36);
}

/**
 * Generate or retrieve session ID from localStorage
 */
export function getOrCreateSessionId() {
  const STORAGE_KEY = 'leebai_session_id';
  const STORAGE_FINGERPRINT_KEY = 'leebai_device_fingerprint';
  
  let sessionId = localStorage.getItem(STORAGE_KEY);
  let deviceFingerprint = localStorage.getItem(STORAGE_FINGERPRINT_KEY);
  
  // Generate fingerprint if not exists
  if (!deviceFingerprint) {
    deviceFingerprint = generateDeviceFingerprint();
    localStorage.setItem(STORAGE_FINGERPRINT_KEY, deviceFingerprint);
  }
  
  // Generate session ID if not exists
  if (!sessionId) {
    sessionId = `${deviceFingerprint}-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
    localStorage.setItem(STORAGE_KEY, sessionId);
  }
  
  return {
    sessionId,
    deviceFingerprint,
  };
}

/**
 * Clear session data (useful when user signs up)
 */
export function clearSessionData() {
  localStorage.removeItem('leebai_session_id');
  localStorage.removeItem('leebai_device_fingerprint');
}

